"use client";
const e = {
  icon: "icon",
  // Only in styled
  loadingIndicator__Text: "loadingIndicator__Text",
  loadingIndicator__Dots: "loadingIndicator__Dots",
  loadingIndicator__Dot: "loadingIndicator__Dot",
  view_toggle: "view_toggle",
  view_toggle_button: "view_toggle_button",
  view_toggle_icon: "view_toggle_icon"
}, a = {
  codeblockContainer: "codeblockContainer",
  codeblockHeader: "codeblockHeader",
  codeblockHeaderLanguage: "codeblockHeaderLanguage",
  codeblockCopyButton: "codeblockCopyButton",
  codeblockHighlighterWrapper: "codeblockHighlighterWrapper",
  codeblockHighlighter: "codeblockHighlighter",
  codeblockCode: "codeblockCode",
  markdownH1: "markdownH1",
  markdownH2: "markdownH2",
  markdownP: "markdownP",
  markdownLi: "markdownLi",
  markdownUl: "markdownUl",
  markdownOl: "markdownOl",
  markdownLink: "markdownLink",
  markdownSourceLink: "markdownSourceLink",
  markdownTable: "markdownTable",
  markdownTh: "markdownTh",
  markdownTd: "markdownTd",
  markdownCode: "markdownCode",
  markdownInput: "markdownInput"
}, t = {
  aiChatWrapper: "aiChatWrapper",
  aiChatConversationLoading: "aiChatConversationLoading",
  aiChatRoot: "aiChatRoot",
  aiChatHeader: "aiChatHeader",
  aiChatHeader__Toolbar: "aiChatHeader__Toolbar",
  aiChatHeader__ToolbarHeader: "aiChatHeader__ToolbarHeader",
  aiChatHeader__ToolbarHeaderWrapper: "aiChatHeader__ToolbarHeaderWrapper",
  aiChatContent: "aiChatContent",
  aiChatContentScrollArea: "aiChatContentScrollArea",
  aiChatContentScrollArea__Viewport: "aiChatContentScrollArea__Viewport",
  aiChatContentScrollArea__Scrollbar: "aiChatContentScrollArea__Scrollbar",
  aiChatContentScrollArea__Thumb: "aiChatContentScrollArea__Thumb",
  aiChatContentScrollArea__Corner: "aiChatContentScrollArea__Corner",
  aiChatDisclaimer: "aiChatDisclaimer",
  aiChatDisclaimerLabel: "aiChatDisclaimerLabel",
  aiChatDisclaimerTrigger: "aiChatDisclaimerTrigger",
  aiChatDisclaimerContent: "aiChatDisclaimerContent",
  aiChatDisclaimerText: "aiChatDisclaimerText",
  aiChatDisclaimerArrow: "aiChatDisclaimerArrow",
  aiChatExampleQuestions: "aiChatExampleQuestions",
  aiChatExampleQuestionsLabel: "aiChatExampleQuestionsLabel",
  aiChatExampleQuestionsList: "aiChatExampleQuestionsList",
  aiChatExampleQuestion: "aiChatExampleQuestion",
  aiChatExampleQuestionButton: "aiChatExampleQuestionButton",
  aiChatWorkflows: "aiChatWorkflows",
  aiChatWorkflowsLabel: "aiChatWorkflowsLabel",
  aiChatWorkflowsList: "aiChatWorkflowsList",
  aiChatWorkflow: "aiChatWorkflow",
  aiChatWorkflow__Icon: "aiChatWorkflow__Icon",
  aiChatMessages: "aiChatMessages",
  aiChatMessageWrapper: "aiChatMessageWrapper",
  aiChatMessageHeader: "aiChatMessageHeader",
  aiChatMessageLoading: "aiChatMessageLoading",
  aiChatMessageAvatar: "aiChatMessageAvatar",
  aiChatMessageAvatarFallback: "aiChatMessageAvatarFallback",
  aiChatMessageAvatarImage: "aiChatMessageAvatarImage",
  aiChatMessageAvatarContent: "aiChatMessageAvatarContent",
  aiChatMessageName: "aiChatMessageName",
  aiChatMessageContentWrapper: "aiChatMessageContentWrapper",
  aiChatMessageContent: "aiChatMessageContent",
  aiChatMessageAttachments: "aiChatMessageAttachments",
  aiChatMessageAttachments__List: "aiChatMessageAttachments__List",
  aiChatMessageAttachments__Item: "aiChatMessageAttachments__Item",
  aiChatMessageAttachments__ItemIcon: "aiChatMessageAttachments__ItemIcon",
  aiChatMessageAttachments__ItemTitle: "aiChatMessageAttachments__ItemTitle",
  aiChatMessageAttachmentsPreview: "aiChatMessageAttachmentsPreview",
  aiChatMessageAttachmentsPreview__Overlay: "aiChatMessageAttachmentsPreview__Overlay",
  aiChatMessageAttachmentsPreview__Content: "aiChatMessageAttachmentsPreview__Content",
  aiChatMessageAttachmentsPreview__Header: "aiChatMessageAttachmentsPreview__Header",
  aiChatMessageAttachmentsPreview__Close: "aiChatMessageAttachmentsPreview__Close",
  aiChatMessageAttachmentsPreview__Body: "aiChatMessageAttachmentsPreview__Body",
  aiChatMessage: "aiChatMessage",
  aiChatMessageToolbar: "aiChatMessageToolbar",
  aiChatMessageToolActions: "aiChatMessageToolActions",
  aiChatMessageToolAction: "aiChatMessageToolAction",
  aiChatMessageAction: "aiChatMessageAction",
  aiChatMessageSources: "aiChatMessageSources",
  aiChatMessageSources__Header: "aiChatMessageSources__Header",
  aiChatMessageSources__List: "aiChatMessageSources__List",
  aiChatMessageSourceItem: "aiChatMessageSourceItem",
  aiChatMessageSourceItem__Icon: "aiChatMessageSourceItem__Icon",
  aiChatMessageSourceItem__Breadcrumbs: "aiChatMessageSourceItem__Breadcrumbs",
  aiChatMessageSourceItem__Breadcrumb: "aiChatMessageSourceItem__Breadcrumb",
  aiChatMessageSourceItem__BreadcrumbIcon: "aiChatMessageSourceItem__BreadcrumbIcon",
  aiChatMessageSourceItem__Title: "aiChatMessageSourceItem__Title",
  aiChatMessageSourceItem__Tag: "aiChatMessageSourceItem__Tag",
  aiChatMessageSourceItem__Description: "aiChatMessageSourceItem__Description",
  aiChatMessageSourceItem__DescriptionPart: "aiChatMessageSourceItem__DescriptionPart",
  aiChatMessageSourceItem__Indicator: "aiChatMessageSourceItem__Indicator",
  aiChatFooter: "aiChatFooter",
  aiChatInput__Fieldset: "aiChatInput__Fieldset",
  aiChatInput__Group: "aiChatInput__Group",
  aiChatInput: "aiChatInput",
  aiChatInput__SendButton: "aiChatInput__SendButton",
  aiChatInput__SendButtonIcon: "aiChatInput__SendButtonIcon",
  aiChatAttachmentsBar: "aiChatAttachmentsBar",
  aiChatAttachmentsBar__List: "aiChatAttachmentsBar__List",
  aiChatAttachmentsBar__Attachment: "aiChatAttachmentsBar__Attachment",
  aiChatAttachmentsBar__AttachmentIcon: "aiChatAttachmentsBar__AttachmentIcon",
  aiChatAttachmentsBar__AttachmentTitle: "aiChatAttachmentsBar__AttachmentTitle",
  aiChatAttachmentsBar__AttachmentDelete: "aiChatAttachmentsBar__AttachmentDelete",
  aiChatAttachmentsBar__Actions: "aiChatAttachmentsBar__Actions",
  aiChatAttachmentsBar__InfoTip: "aiChatAttachmentsBar__InfoTip",
  aiChatAttachmentsBar__InfoTipIcon: "aiChatAttachmentsBar__InfoTipIcon",
  aiChatAttachmentsBar__InfoTipArrow: "aiChatAttachmentsBar__InfoTipArrow",
  aiChatAttachmentsBar__InfoTipText: "aiChatAttachmentsBar__InfoTipText",
  aiChatAttachmentsBar__Inputs: "aiChatAttachmentsBar__Inputs",
  aiChatAttachmentsBar__Input: "aiChatAttachmentsBar__Input",
  aiChatAttachmentsBar__InputIcon: "aiChatAttachmentsBar__InputIcon",
  aiChatAttachmentsBar__Modal: "aiChatAttachmentsBar__Modal",
  aiChatAttachmentsBar__ModalOverlay: "aiChatAttachmentsBar__ModalOverlay",
  aiChatAttachmentsBar__ModalContent: "aiChatAttachmentsBar__ModalContent",
  aiChatAttachmentsBar__ModalHeader: "aiChatAttachmentsBar__ModalHeader",
  aiChatAttachmentsBar__ModalClose: "aiChatAttachmentsBar__ModalClose",
  aiChatAttachmentsBar__ModalBody: "aiChatAttachmentsBar__ModalBody",
  aiChatAttachmentsBar__ModalHeading: "aiChatAttachmentsBar__ModalHeading",
  aiChatAttachmentsBar__ModalDescription: "aiChatAttachmentsBar__ModalDescription",
  aiChatAttachmentsBar__ModalHelp: "aiChatAttachmentsBar__ModalHelp",
  aiChatAttachmentsBar__Form: "aiChatAttachmentsBar__Form",
  aiChatAttachmentsBar__FormTitle: "aiChatAttachmentsBar__FormTitle",
  aiChatAttachmentsBar__FormTitleLabel: "aiChatAttachmentsBar__FormTitleLabel",
  aiChatAttachmentsBar__FormTitleInput: "aiChatAttachmentsBar__FormTitleInput",
  aiChatAttachmentsBar__FormTitleError: "aiChatAttachmentsBar__FormTitleError",
  aiChatAttachmentsBar__FormContent: "aiChatAttachmentsBar__FormContent",
  aiChatAttachmentsBar__FormContentLabel: "aiChatAttachmentsBar__FormContentLabel",
  aiChatAttachmentsBar__FormContentInput: "aiChatAttachmentsBar__FormContentInput",
  aiChatAttachmentsBar__FormContentError: "aiChatAttachmentsBar__FormContentError",
  aiChatAttachmentsBar__FormSubmitButton: "aiChatAttachmentsBar__FormSubmitButton",
  aiChatActionBar: "aiChatActionBar",
  aiChat__ChatActions: "aiChat__ChatActions",
  aiChat__ChatAction: "aiChat__ChatAction",
  aiChat__ChatActionLabel: "aiChat__ChatActionLabel",
  aiChat__ChatActionFeeback: "aiChat__ChatActionFeeback",
  aiChatHelpActions: "aiChatHelpActions",
  aiChatHelpAction: "aiChatHelpAction",
  aiChatHelpActions__Trigger: "aiChatHelpActions__Trigger",
  aiChatHelpActions__Menu: "aiChatHelpActions__Menu",
  aiChatHelpActions__MenuArrow: "aiChatHelpActions__MenuArrow",
  aiChatHelpActions__MenuItem: "aiChatHelpActions__MenuItem",
  aiChatHelpActions_MenuItemIcon: "aiChatHelpActions_MenuItemIcon",
  aiChatTagline__Container: "aiChatTagline__Container",
  aiChatTagline__Text: "aiChatTagline__Text",
  aiChatTagline__Logo: "aiChatTagline__Logo",
  aiChatTagline__BrandName: "aiChatTagline__BrandName",
  aiChatFeedbackModal: "aiChatFeedbackModal",
  aiChatFeedbackModal__Overlay: "aiChatFeedbackModal__Overlay",
  aiChatFeedbackModal__Content: "aiChatFeedbackModal__Content",
  aiChatFeedbackModal__Header: "aiChatFeedbackModal__Header",
  aiChatFeedbackModal__Close: "aiChatFeedbackModal__Close",
  aiChatFeedbackModal__Body: "aiChatFeedbackModal__Body",
  aiChatFeedbackForm: "aiChatFeedbackForm",
  aiChatFeedbackItem: "aiChatFeedbackItem",
  aiChatFeedbackItem__Checkbox: "aiChatFeedbackItem__Checkbox",
  aiChatFeedbackItem__CheckboxIndicator: "aiChatFeedbackItem__CheckboxIndicator",
  aiChatFeedbackItem__Label: "aiChatFeedbackItem__Label",
  aiChatFeedbackItem__Description: "aiChatFeedbackItem__Description",
  aiChatFeedbackForm__SubmitButton: "aiChatFeedbackForm__SubmitButton",
  aiChatForm__Wrapper: "aiChatForm__Wrapper",
  aiChatForm: "aiChatForm",
  aiChatForm__Close: "aiChatForm__Close",
  aiChatForm__Header: "aiChatForm__Header",
  aiChatForm__Heading: "aiChatForm__Heading",
  aiChatForm__Description: "aiChatForm__Description",
  aiChatForm__Content: "aiChatForm__Content",
  aiChatForm__Field: "aiChatForm__Field",
  aiChatForm__FieldLabel: "aiChatForm__FieldLabel",
  aiChatForm__FieldText: "aiChatForm__FieldText",
  aiChatForm__FieldEmail: "aiChatForm__FieldEmail",
  aiChatForm__FieldFile: "aiChatForm__FieldFile",
  aiChatForm__FieldTextArea: "aiChatForm__FieldTextArea",
  aiChatForm__FieldCheckbox: "aiChatForm__FieldCheckbox",
  aiChatForm__FieldCheckboxIndicator: "aiChatForm__FieldCheckboxIndicator",
  aiChatForm__FieldSelect: "aiChatForm__FieldSelect",
  aiChatForm__FieldSelect__Trigger: "aiChatForm__FieldSelect__Trigger",
  aiChatForm__FieldSelect__Value: "aiChatForm__FieldSelect__Value",
  aiChatForm__FieldSelect__Icon: "aiChatForm__FieldSelect__Icon",
  aiChatForm__FieldSelect__Content: "aiChatForm__FieldSelect__Content",
  aiChatForm__FieldSelect__Viewport: "aiChatForm__FieldSelect__Viewport",
  aiChatForm__FieldSelect__Item: "aiChatForm__FieldSelect__Item",
  aiChatForm__FieldSelect__ItemIndicator: "aiChatForm__FieldSelect__ItemIndicator",
  aiChatForm__FieldSelect__ItemText: "aiChatForm__FieldSelect__ItemText",
  aiChatForm__FieldError: "aiChatForm__FieldError",
  aiChatForm__Error: "aiChatForm__Error",
  aiChatForm__Footer: "aiChatForm__Footer",
  aiChatForm__Cancel: "aiChatForm__Cancel",
  aiChatForm__Submit: "aiChatForm__Submit",
  aiChatForm__Success: "aiChatForm__Success",
  aiChatForm__SuccessHeading: "aiChatForm__SuccessHeading",
  aiChatForm__SuccessMessage: "aiChatForm__SuccessMessage",
  aiChatForm__SuccessButton: "aiChatForm__SuccessButton",
  //
  aiChatLink: "aiChatLink"
}, _ = {
  aiSearchWrapper: "aiSearchWrapper",
  aiSearchRoot: "aiSearchRoot",
  aiSearchContent: "aiSearchContent",
  aiSearchInputGroup: "aiSearchInputGroup",
  aiSearchInputIcon: "aiSearchInputIcon",
  aiSearchInput: "aiSearchInput",
  aiSearchLoading: "aiSearchLoading",
  aiAskAITrigger: "aiAskAITrigger",
  aiAskAITrigger__Icon: "aiAskAITrigger__Icon",
  aiAskAITrigger__Label: "aiAskAITrigger__Label",
  aiAskAITrigger__Indicator: "aiAskAITrigger__Indicator",
  aiSearchResults: "aiSearchResults",
  aiSearchResults__Loading: "aiSearchResults__Loading",
  aiSearchResults__Empty: "aiSearchResults__Empty",
  aiSearchResults__TabList: "aiSearchResults__TabList",
  aiSearchResults__Tab: "aiSearchResults__Tab",
  aiSearchResults__Content: "aiSearchResults__Content",
  aiSearchResults__ScrollArea: "aiSearchResults__ScrollArea",
  aiSearchResults__ScrollAreaViewport: "aiSearchResults__ScrollAreaViewport",
  aiSearchResults__List: "aiSearchResults__List",
  aiSearchResults__Item: "aiSearchResults__Item",
  aiSearchResults__ItemIcon: "aiSearchResults__ItemIcon",
  aiSearchResults__ItemBreadcrumbs: "aiSearchResults__ItemBreadcrumbs",
  aiSearchResults__ItemBreadcrumbIcon: "aiSearchResults__ItemBreadcrumbIcon",
  aiSearchResults__ItemTitle: "aiSearchResults__ItemTitle",
  aiSearchResults__ItemTag: "aiSearchResults__ItemTag",
  aiSearchResults__ItemDescription: "aiSearchResults__ItemDescription",
  aiSearchResults__ItemDescriptionPart: "aiSearchResults__ItemDescriptionPart",
  aiSearchResults__ItemIndicator: "aiSearchResults__ItemIndicator",
  aiSearchResults__ItemPreview: "aiSearchResults__ItemPreview",
  aiSearchResults__ItemPreview__Header: "aiSearchResults__ItemPreview__Header",
  aiSearchResults__ItemPreview__Heading: "aiSearchResults__ItemPreview__Heading",
  aiSearchResults__ItemPreview__Title: "aiSearchResults__ItemPreview__Title",
  aiSearchResults__ItemPreview__Title__LinkIcon: "aiSearchResults__ItemPreview__Title__LinkIcon",
  aiSearchResults__ItemPreview__Breadcrumbs: "aiSearchResults__ItemPreview__Breadcrumbs",
  aiSearchResults__ItemPreview__BreadcrumbIcon: "aiSearchResults__ItemPreview__BreadcrumbIcon",
  aiSearchResults__ItemPreview__Body: "aiSearchResults__ItemPreview__Body",
  aiSearchResults__ItemPreview__Outline: "aiSearchResults__ItemPreview__Outline",
  aiSearchResults__ItemPreview__Outline__Title: "aiSearchResults__ItemPreview__Outline__Title",
  aiSearchResults__ItemPreview__Outline__List: "aiSearchResults__ItemPreview__Outline__List",
  aiSearchResults__ItemPreview__Outline__Item: "aiSearchResults__ItemPreview__Outline__Item",
  aiSearchResults__ItemPreview__Outline__ItemIcon: "aiSearchResults__ItemPreview__Outline__ItemIcon",
  aiSearchResults__ItemPreview__Outline__ItemText: "aiSearchResults__ItemPreview__Outline__ItemText",
  aiSearchResults__ItemPreview__Outline__ItemLinkIcon: "aiSearchResults__ItemPreview__Outline__ItemLinkIcon",
  aiSearchResults__ScrollAreaScrollbar: "aiSearchResults__ScrollAreaScrollbar",
  aiSearchResults__ScrollAreaThumb: "aiSearchResults__ScrollAreaThumb",
  aiSearchResults__ScrollAreaCorner: "aiSearchResults__ScrollAreaCorner",
  aiSearchFooter: "aiSearchFooter",
  aiSearchTagline__Container: "aiSearchTagline__Container",
  aiSearchTagline__Text: "aiSearchTagline__Text",
  aiSearchTagline__Logo: "aiSearchTagline__Logo",
  aiSearchTagline__BrandName: "aiSearchTagline__BrandName"
}, i = {
  modal: "modal",
  modal__Overlay: "modal__Overlay",
  modal__Content: "modal__Content",
  modal__Close: "modal__Close"
}, r = {
  chatButton__Text: "chatButton__Text",
  chatButton__Button: "chatButton__Button",
  chatButton__Container: "chatButton__Container",
  chatButton__AvatarImage: "chatButton__AvatarImage",
  chatButton__AvatarContent: "chatButton__AvatarContent"
}, o = {
  intelligentForm__Root: "intelligentForm__Root",
  intelligentForm__Heading: "intelligentForm__Heading",
  intelligentForm__Content: "intelligentForm__Content",
  intelligentForm__Content__ScrollArea: "intelligentForm__Content__ScrollArea",
  intelligentForm__Content__ScrollAreaViewport: "intelligentForm__Content__ScrollAreaViewport",
  intelligentForm__Content__ScrollAreaScrollbar: "intelligentForm__Content__ScrollAreaScrollbar",
  intelligentForm__Content__ScrollAreaThumb: "intelligentForm__Content__ScrollAreaThumb",
  intelligentForm__Content__ScrollAreaCorner: "intelligentForm__Content__ScrollAreaCorner",
  intelligentForm__Success: "intelligentForm__Success",
  intelligentForm__SuccessIcon: "intelligentForm__SuccessIcon",
  intelligentForm__SuccessHeading: "intelligentForm__SuccessHeading",
  intelligentForm__SuccessMessage: "intelligentForm__SuccessMessage",
  intelligentForm__PrimaryForm: "intelligentForm__PrimaryForm",
  intelligentForm__PrimaryForm__Description: "intelligentForm__PrimaryForm__Description",
  intelligentForm__PrimaryFormFields: "intelligentForm__PrimaryFormFields",
  intelligentForm__PrimaryFormSubmit: "intelligentForm__PrimaryFormSubmit",
  intelligentForm__Field: "intelligentForm__Field",
  intelligentForm__FieldLabel: "intelligentForm__FieldLabel",
  intelligentForm__FieldText: "intelligentForm__FieldText",
  intelligentForm__FieldEmail: "intelligentForm__FieldEmail",
  intelligentForm__FieldFile: "intelligentForm__FieldFile",
  intelligentForm__FieldTextArea: "intelligentForm__FieldTextArea",
  intelligentForm__FieldCheckbox: "intelligentForm__FieldCheckbox",
  intelligentForm__FieldCheckboxIndicator: "intelligentForm__FieldCheckboxIndicator",
  intelligentForm__FieldSelect: "intelligentForm__FieldSelect",
  intelligentForm__FieldSelect__Trigger: "intelligentForm__FieldSelect__Trigger",
  intelligentForm__FieldSelect__Value: "intelligentForm__FieldSelect__Value",
  intelligentForm__FieldSelect__Icon: "intelligentForm__FieldSelect__Icon",
  intelligentForm__FieldSelect__Content: "intelligentForm__FieldSelect__Content",
  intelligentForm__FieldSelect__Viewport: "intelligentForm__FieldSelect__Viewport",
  intelligentForm__FieldSelect__Item: "intelligentForm__FieldSelect__Item",
  intelligentForm__FieldSelect__ItemIndicator: "intelligentForm__FieldSelect__ItemIndicator",
  intelligentForm__FieldSelect__ItemText: "intelligentForm__FieldSelect__ItemText",
  intelligentForm__FieldError: "intelligentForm__FieldError",
  intelligentForm__BotHeading: "intelligentForm__BotHeading",
  intelligentForm__BotHeading__Icon: "intelligentForm__BotHeading__Icon",
  intelligentForm__BotHeading__Name: "intelligentForm__BotHeading__Name",
  intelligentForm__Loading: "intelligentForm__Loading",
  intelligentForm__ConfidentResponse: "intelligentForm__ConfidentResponse",
  intelligentForm__ConfidentAnswer: "intelligentForm__ConfidentAnswer",
  intelligentForm__ConfidentResponseButton: "intelligentForm__ConfidentResponseButton",
  intelligentForm__ConfidentResponseButton__Icon: "intelligentForm__ConfidentResponseButton__Icon",
  intelligentForm__ConfidentResponseButton__Label: "intelligentForm__ConfidentResponseButton__Label",
  intelligentForm__SecondaryForm: "intelligentForm__SecondaryForm",
  intelligentForm__SecondaryForm__Description: "intelligentForm__SecondaryForm__Description",
  intelligentForm__SecondaryFormFields: "intelligentForm__SecondaryFormFields",
  intelligentForm__SecondaryFormSubmit: "intelligentForm__SecondaryFormSubmit",
  intelligentForm__Error: "intelligentForm__Error",
  intelligentForm__Sources: "intelligentForm__Sources",
  intelligentForm__SourcesCaption: "intelligentForm__SourcesCaption",
  intelligentForm__SourcesList: "intelligentForm__SourcesList",
  intelligentForm__Source: "intelligentForm__Source",
  intelligentForm__SourceIcon: "intelligentForm__SourceIcon",
  intelligentForm__SourceTitle: "intelligentForm__SourceTitle"
}, n = {
  searchBar__Container: "searchBar__Container",
  searchBar__Button: "searchBar__Button",
  searchBar__ContentWrapper: "searchBar__ContentWrapper",
  searchBar__Text: "searchBar__Text",
  searchBar__Icon: "searchBar__Icon",
  searchBar__KbdWrapper: "searchBar__KbdWrapper",
  searchBar__CmdIcon: "searchBar__CmdIcon",
  searchBar__Ctrl: "searchBar__Ctrl",
  searchBar__KbdShortcutKey: "searchBar__KbdShortcutKey"
}, l = {
  //
  //
  ...a,
  ...t,
  ..._,
  ...i,
  ...r,
  ...n,
  ...o,
  ...e
};
export {
  n as SearchBarComponentIds,
  t as aiChatComponentIds,
  _ as aiSearchComponentIds,
  r as chatButtonComponentIds,
  l as componentIDs,
  o as intelligentFormComponentIds,
  a as markDownComponentIds,
  e as miscellanousComponentIds,
  i as modalComponentIds
};
